export default __webpack_public_path__ + "static/media/Custom_Valkyrie.105f320e.svg";